import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { environment } from 'src/environments/environment';
import { ConfigHelper } from './core/services/helpers/config.helper';
import { ShoppingCartService } from './core/services/shopping-cart.service';

declare var QueueIt;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  isProduction: boolean = environment.production;

  brands = [{
    name: "cael",
    colors: ["#a6192e", "#851425", "#fff", "#fff"]
  }];

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private configHelper: ConfigHelper
  ) {
    let dataLayer = window['dataLayer'] || [];

    this.router.events.subscribe(event => {

      if (typeof QueueIt !== 'undefined') {
        try {
          QueueIt.validateUser();
        }
        catch (err) {
          console.log("Failed to called QueueIt.validateUser();")
        }
      }

      if (event instanceof NavigationEnd) {
        dataLayer.push({
          event: 'ngRouteChange',
          attributes: {
            route: event.urlAfterRedirects
          }
        });
      }
    });
  }

  ngOnInit() {
    const body = document.querySelector('body');
    body.className = this.configHelper.getBrandName()?.toLowerCase();
    const brand = this.brands.find(x => x.name === body.className);
    if (brand) {
      body.style.setProperty('--primary', brand.colors[0]);
      body.style.setProperty('--primary-darken', brand.colors[1]);
      body.style.setProperty('--primary-button-text-color', brand.colors[2]);
      body.style.setProperty('--header-cart-item', brand.colors[3]);
    }
    this.shoppingCartService.getShoppingCart();
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }
}
